export class mpTicketRequestModel{
    url?:string;
}